import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'file360-retrieval-redirect',
  templateUrl: './retrieval-redirect.component.html',
  styleUrls: ['./retrieval-redirect.component.scss']
})
export class RetrievalRedirectComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute,) { }

  ngOnInit(): void {

    // Lazy-loaded module caused an extra layer to
    // be added to the retrieval route (/home/retrieve instead of /retrieve).
    // This redirector redirects from /retrieve to /home/retrieve, along with
    // template parameters. Added for backwards compatibility.
    // The extra route level can be removed once this Angular bug is fixed.
    // https://github.com/angular/angular/issues/12842

    const retId = this.route.snapshot.firstChild?.paramMap.get("id");
    console.log(`!!!!!!!!!!!!!!! REDIRECTING TO ${retId} !!!!!!!!!!!!!!!!!`);
    const params = this.route.snapshot.firstChild?.params;
    console.log(params);
    this.router.navigate(['/home/retrieve',
      {
        outlets:
        {
          template: [retId, params],
          retrieve: ["results"]
        }
      }]);
  }

}
